import React from "react";
const BillIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"><path d="M10 6a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v38l-7-5-7 5-7-5-7 5z"></path><path d="M18 22h12"></path><path d="M18 30h12"></path><path d="M18 14h12"></path></g></svg>
  )
}
export default BillIcon;